import Swiper, { Navigation, Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function basicSlider() {
    document.querySelectorAll('.swiper').forEach((el) => {
        const paginationEl = el.querySelector('.swiper-pagination');
        const nextEl = el.querySelector('.swiper-button-next');
        const prevEl = el.querySelector('.swiper-button-prev');

        const config = {
            autoHeight: true,
            effect: 'slide',
            loop: true,
            modules: [Navigation, Pagination],
        };

        if (nextEl && prevEl) {
            config.navigation = {
                nextEl,
                prevEl,
            };
        }

        if (paginationEl) {
            config.pagination = {
                el: paginationEl,
                type: 'bullets',
            };
        }

        // Swiper is constructed for side effects only (no instance reference retained).
        // eslint-disable-next-line no-new -- Swiper API
        new Swiper(el, config);
    });
}
